module.exports = __webpack_public_path__ + "static/media/ar.2588d76d.webp";